import { c as _c } from "react/compiler-runtime";
import { cn } from '@/utils/cn';
import { getDefaultImage } from '@/utils/get-default-image';
import { getInitials } from '@/utils/get-initials';
import { Avatar, AvatarFallback, AvatarImage } from './avatar';
type UserAvatarProps = React.ComponentProps<typeof Avatar> & {
  id: string;
  name: string;
  image?: string | null;
};
export function UserAvatar(props) {
  const $ = _c(23);
  let className;
  let id;
  let image;
  let name;
  let rest;
  if ($[0] !== props) {
    ({
      id,
      name,
      image,
      className,
      ...rest
    } = props);
    $[0] = props;
    $[1] = className;
    $[2] = id;
    $[3] = image;
    $[4] = name;
    $[5] = rest;
  } else {
    className = $[1];
    id = $[2];
    image = $[3];
    name = $[4];
    rest = $[5];
  }
  let t0;
  if ($[6] !== className) {
    t0 = cn("@container", className);
    $[6] = className;
    $[7] = t0;
  } else {
    t0 = $[7];
  }
  let t1;
  if ($[8] !== id || $[9] !== image) {
    t1 = image ?? getDefaultImage(id);
    $[8] = id;
    $[9] = image;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  let t2;
  if ($[11] !== name || $[12] !== t1) {
    t2 = <AvatarImage src={t1} alt={name} />;
    $[11] = name;
    $[12] = t1;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  let t3;
  if ($[14] !== name) {
    t3 = getInitials(name);
    $[14] = name;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  let t4;
  if ($[16] !== t3) {
    t4 = <AvatarFallback className="text-[40cqi]">{t3}</AvatarFallback>;
    $[16] = t3;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  let t5;
  if ($[18] !== rest || $[19] !== t0 || $[20] !== t2 || $[21] !== t4) {
    t5 = <Avatar className={t0} {...rest}>{t2}{t4}</Avatar>;
    $[18] = rest;
    $[19] = t0;
    $[20] = t2;
    $[21] = t4;
    $[22] = t5;
  } else {
    t5 = $[22];
  }
  return t5;
}